import type { ExpensePolicyTypeValue } from "./ExpensePolicyTypeValue.enum";

export enum ExpensePolicyBy {
  GROUP = "customer_employee_group",
  NONE = "none",
}

export type ExpensePolicy = {
  uuid: string;
  policy: {
    uuid?: string;
    name?: string;
  };
  group?: {
    uuid: string;
    description: string;
  };
  expenseType: {
    uuid: string;
    name: string;
  };
  expenseCategory: {
    uuid: string;
    name: string;
  };
  policyParameterExpense: {
    uuid: string;
    type: string;
    slug: string;
    description: string;
  };
  typeValue: ExpensePolicyTypeValue;
  value: number;
  voucherRequired: boolean;
  isActive: boolean;
};
